import React from 'react'
import { Typography as MUITypography, TypographyProps as MUITypographyProps, Stack } from '@mui/material'

export interface TypographyProps extends MUITypographyProps {
  leftIcon?: React.ReactNode
}

export enum TypographyColor {
  PRIMARY = 'primary.main',
  SECONDARY = 'secondary.light',
  INFO = 'info.main',
  SUCCESS = 'success.main',
  WARNING = 'warning.main',
  ERROR = 'error.main',
}

const Typography: React.FC<TypographyProps> = (props) => {
  const { sx, color, leftIcon, ...rest } = props
  const typography = <MUITypography color={color} sx={{
    ...(color === undefined ? { color: 'text.primary' } : {}),
    ...sx
  }} {...rest} />

  if (leftIcon) {
    return (
      <Stack direction='row' spacing={1} alignItems='center'>
        {leftIcon}
        {typography}
      </Stack>
    )
  }

  return typography
}

export default Typography
